module.exports = __webpack_public_path__ + "img/teams.dbb473c2.png";